import app from "./app";
import decorate from "./decorate";
import cart from "./cart";
export default {
	app,
	decorate,
	cart
};
